import React from 'react'
import { ISearchAndFilterAdvert } from '../../../context/search/types'
import Image from '../../Image'

interface ISearchResultsAdvertComponent {
  advert: ISearchAndFilterAdvert
}

const CollectionAdvert: React.FC<ISearchResultsAdvertComponent> = ({ advert }): JSX.Element => {
  return (
    <a className={`ad-banner${advert.full_width ? ' ad-banner--full' : ''}`} href={ advert.cta_link }>
      {advert.image_mobile ? (
        <div className="ad-banner__image ad-banner__image--mb">
          <Image src={advert.image_mobile} width={800} height={600} />
        </div>
      ) : null}
      {advert.image_desktop ? (
        <div className="ad-banner__image ad-banner__image--dt">
          <Image src={advert.image_desktop} width={800} height={600} />
        </div>
      ) : null}
      <div className="ad-banner__inner">
        {advert.title ? (
          <h3 className="ad-banner__header heading-2">{ advert.title }</h3>
        ) : null}
        {advert.cta_text ? (
          <button type="button" className="ad-banner__cta btn-3">
            { advert.cta_text }
          </button>
        ) : null}
      </div>
    </a>
  )
}

export default CollectionAdvert